<template>
  <div id="spree-page">
    <minibanners-shelves :minibanners="minibanners" :showcases="showcases" />

    <div v-if="$store.state.userInteracted && devicePage">
      <div v-html="html"></div>
    </div>

    <div v-if="$store.state.userInteracted && homeMiddleShelves && !devicePage">
      <div v-html="homeMiddleShelves"></div>
    </div>

    <featured-reviews
      v-if="$store.state.userInteracted && !devicePage"
      :home-reviews="homeReviews"
      :home-review-block="homeReviewBlock"
    />

    <div v-if="$store.state.userInteracted && homeBrandBlock">
      <div v-html="homeBrandBlock"></div>
    </div>
    <brand-icons v-else-if="$store.state.userInteracted" />

    <stamped-io-feed
      v-if="
        $store.state.userInteracted && !Array.isArray(showcases) && $isBrStore
      "
    />
  </div>
</template>

<script>
import MinibannersShelves from '~/components/pages/MinibannersShelves.vue'

import pushDataLayer from '~/mixins/gtm/push-data-layer'

const BrandIcons = () =>
  import(
    /* webpackChunkName: "brand-icons" */ '~/components/brand-icons/BrandIcons.vue'
  )

const StampedIoFeed = () =>
  import(
    /* webpackChunkName: "stamped-io-feed" */ '~/components/pages/stampedio-feed/StampedIoFeed.vue'
  )

const FeaturedReviews = () =>
  import(
    /* webpackChunkName: "featured-reviews */ '~/components/pages/featured-reviews/FeaturedReviews.vue'
  )

export default {
  name: 'SpreePage',
  components: {
    MinibannersShelves,
    BrandIcons,
    StampedIoFeed,
    FeaturedReviews,
  },
  mixins: [pushDataLayer],
  props: {
    minibanners: {
      type: Array,
      required: true,
    },
    showcases: {
      type: Object,
      required: true,
    },
    taxonSlug: {
      type: String,
      required: true,
    },
    homeReviews: {
      type: String,
      default: '',
    },
    homeReviewBlock: {
      type: String,
      required: false,
    },
    homeMiddleShelves: {
      type: String,
      required: false,
    },
    homeBrandBlock: {
      type: String,
      required: false,
    },
    html: {
      type: String,
      default: '',
    },
    devicePage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userInteracted: false,
    }
  },
  watch: {
    '$store.state.userInteracted'() {
      this.sendToGtm()
    },
  },
  mounted() {
    if (this.$store.state.userInteracted) {
      this.sendToGtm()
    }
  },
  methods: {
    sendToGtm() {
      this.pushDataLayer({
        event: 'genericEvent',
        eventCategory: 'navigation',
        eventAction: 'viewSpreePage',
        eventValue: {},
      })
    },
  },
}
</script>

<style lang="scss">
@import '~/assets/css/cms-page.scss';
@import '~/assets/css/container.scss';
</style>
